<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { db } from "./plugins/firebase";
export default {
  name: "app",
  mounted() {
    const urlSearchParams = new URLSearchParams(
      window.location.href.substring(window.location.href.indexOf("?c") + 1)
    );
    const params = Object.fromEntries(urlSearchParams.entries());
    console.log("params", JSON.stringify(params));
    // if (params.c != "11112105" && params.c != "11112199" && params.c != "11112200" && params.c != "9901") {
    if (params.o === "Weborders") {
      console.log("Going to Weborders...");
      window.location.href = `https://borders.bistrosoft.com/menu/weborders?commerceId=${params.c}`;
    } else {
      console.log("Going to Menu...");
      db.ref(`products/${params.c}`)
        .once("value")
        .then(function(snapshot) {
          var list = snapshot.val();
          if (list.idList != null) {
            db.ref(`listProducts/${list.idList}/menues`)
              .once("value")
              .then(function(snapshotMenues) {
                var menues = snapshotMenues.val();
                if (menues !== null && menues !== undefined) {
                  menues.forEach(m => {
                    m.origins.forEach(o => {
                      if (o.name == params.o) {
                        window.location.href = `https://borders.bistrosoft.com/menu?commerceId=${params.c}&menuUUID=${m.uuid}`;
                      }
                    });
                  });
                }
              });
          }
        });
    }

    // }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue